/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup';
import { CoverageCheckupState } from '../../store/step';

export const SelectAnOptionSchema = Yup.string().required(
  'please select an option'
);

export function createSelectOptionSchema(
  fieldName: keyof CoverageCheckupState
): Yup.ObjectSchema<any> {
  return Yup.object().shape({ [fieldName]: SelectAnOptionSchema });
}
